module.exports = require("fs");


/*****************
 ** WEBPACK FOOTER
 ** external "fs"
 ** module id = 7
 ** module chunks = 0
 **/